package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/flutter/freezed")
@Composable
fun FreezedFPage() {
    BlogLayout(
        PageProperties(
            "Freezed",
            "Annotations for the freezed code-generator, Dart classes automatically generates code for converting to and from JSON. The JsonSerializable annotation will generate code for a class to/from JSON."
        ),
        BlogProperties("Flutter", "Freezed annotation")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Traditional Approach",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Let’s say you have a Person class with properties like name, age, and email. To make it immutable, you’d typically write something like this:",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    class Person {
                      final String name;
                      final int age;
                      final String email;

                      Person({required this.name, required this.age, required this.email});

                      Person copyWith({String? name, int? age, String? email}) {
                        return Person(
                          name: name ?? this.name,
                          age: age ?? this.age,
                          email: email ?? this.email,
                        );
                      }

                      @override
                      bool operator ==(Object other) {
                        // Equality comparison implementation
                      }

                      @override
                      int get hashCode {
                        // Hash code implementation
                      }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "freezed annotations",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "freezed_annotation: Annotations for the freezed code-generator.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "freezed: Code generator with a simple API that can handle complex use-cases.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "build_runner: It generates model files and watches for any changes, and rebuilds the models accordingly.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "json_serializable: Annotating Dart classes automatically generates code for converting to and from JSON. The JsonSerializable annotation will generate code for a class to/from JSON.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "json_annotation: Json_serializable uses annotations to define its operations.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "@freezed vs @Freezed : @freezed by default plugins allow annotation, no modified annotation. @Freezed, you can modify annotation. The factory initializer specifies also the properties declared by this value type. Freezed creates value objects by using code generation to create sealed classes and unions which are as a base feature are in fact value objects. For example: No need to copyWith in freezed use to annotation",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    @Freezed(
                      // Disable the generation of copyWith/==
                      copyWith: false,
                      equal: false,
                    )
                    """.trimIndent()
            )

            SpanText(
                text = "By default freezed annotation is false are: fromJson, toJson",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    class Freezed {
                    /// {@template freezed_annotation.freezed}
                    const Freezed({
                        this.unionKey,
                        this.unionValueCase,
                        this.fallbackUnion,
                        this.copyWith,
                        this.equal,
                        this.toStringOverride,
                        this.fromJson,
                        this.toJson,
                        this.map,
                        this.when,
                        this.makeCollectionsUnmodifiable,
                        this.addImplicitFinal = true,
                        this.genericArgumentFactories = false,
                    });
                """.trimIndent()
            )

            SpanText(
                text = "Key Features of the freezed Package",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Immutable Models: With freezed, the generated models are immutable by default. This prevents unintended changes to data and enhances predictability in your application's behavior.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "Union Types: freezed allows you to define union types, which represent a value that could be one of several possible types. This is particularly useful for scenarios like representing different states of an entity.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "Pattern Matching: The package provides a powerful pattern matching mechanism, similar to pattern matching in functional programming languages. This helps in handling different cases of union types with ease.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "CopyWith Method: freezed generates a copyWith method for each model, enabling you to create modified copies of objects without modifying the original object itself.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "Equatable: The generated models implement the Equatable interface, making it easy to compare instances for equality.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "Less boilerplate: With @freezed, you write significantly less code, making your codebase cleaner and more maintainable.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Generate Code using freezed",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    flutter pub run build_runner build --delete-conflicting-outputs

                    flutter pub run build_runner watch

                    flutter pub run build_runner build

                    dart run build_runner build
                    """.trimIndent()
            )

            SpanText(
                text = "Assertions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "On the topic of assertions, just because freezed adds in an assert(x != null) for a required or @Default member, it doesn't mean that we don't want to add our own assert statements.",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li {
                    SpanText(
                        text = "maybeMap, same as a map but no need to implement each case and adds an orElse for the fallback option.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "when, same as a map, except that the values are deconstructed.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li {
                    SpanText(
                        text = "maybeWhen, same as when but no need to implement each case and adds an orElse for the fallback option.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

            }

            KotlinCode(
                code = $$"""
                    @freezed
                    abstract class Product with _$Product {
                      const Product._();

                      @Assert("name != 'iPhone 13', 'iPhone 13 has yet to be released!'")
                      const factory Product.phone({
                        required String id,
                        required String name,
                        @Default(Colors.red) Color color,
                      }) = _Phone;

                      const factory Product.insurance({
                        required String id,
                        required String name,
                        required double quote,
                      }) = _Insurance;

                      @override
                      String toString() {
                        return "Product ID = $id, Name = $name";
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    import 'package:freezed_annotation/freezed_annotation.dart';

                    part 'failure.freezed.dart';

                    @freezed
                    abstract class Failure with _$Failure {
                      const factory Failure(String message) = _Failure;
                      const factory Failure.network(
                              [@Default("You've got no internet connection.") String message]) =
                          NetworkFailure;
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Sealed class",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    part 'result.freezed.dart';

                    @freezed
                    abstract class Result<T> with _$Result {
                      const factory Result.success(T value) = Success<T>;
                      const factory Result.failure(Error error) = Failure<T>;
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    result.when(
                      success: (value) => _doSomethingCleverWith(value),
                      failure: (error) => _handle(error),
                    );
                    """.trimIndent()
            )

            SpanText(
                text = "Linter rules",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    analyzer:
                     exclude:
                      - "**/*.g.dart"
                      - "**/*.freezed.dart"
                      
                    errors:
                     invalid_annotation_target: ignore
                     overridden_fields : ignore
                     library_private_types_in_public_api : ignore
                    """.trimIndent()
            )
        }
    }
}

